import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./app";
import "./app.css";
import { loadPublicConfig } from "./lib/publicConfig";

// NOTE: React.StrictMode is intentionally OFF. Cesium's imperative camera
// API doesn't tolerate double-mount (cleanup races flyTo). We can re-enable
// StrictMode once every imperative Cesium effect has been audited.

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");

// Cesium reads Ion.defaultAccessToken when its module first loads, so the
// deployment's token has to be in hand before anything renders — an effect
// inside a component would run after that import and leave the globe
// unauthenticated. One same-origin request, and `finally` means an API that is
// down delays the app rather than preventing it from starting.
void loadPublicConfig().finally(() => {
  ReactDOM.createRoot(root).render(
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </QueryClientProvider>,
  );
});
